import { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../context/DataContext';
import { iconColorPalette } from '../../styling/Colors';
import { getIconIndex } from '../util/formatter';

export const useCustomMapMarker = () => {
  const { locdata, mapMarkerSettingData, mapMarkerUserSettingData } = useContext(GlobalContext);
  const [data] = locdata;
  const [mapMarkerSetting] = mapMarkerSettingData;
  const [,setMapMarkerUserSetting] = mapMarkerUserSettingData;
  const [customizationMarkersOptions, setCustomizationMarkersOptions] =
    useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const toggleIsOpen = () => {
    setSelectedRow(null);
    setIsOpen((prevState) => !prevState);
  };

  const handleSave = () => {
    setMapMarkerUserSetting((prevState) => ({
      ...prevState,
      ...customizationMarkersOptions
    }));
    localStorage.setItem(
      // TODO: use consts for that key
      'iconMappingUser',
      JSON.stringify(customizationMarkersOptions)
    );
    toggleIsOpen();
  };

  const combineUserAndSystemMapMarkerOptions = () => {
    /**
     * @type {Map<string, {id: string; name: string;}>}
     */
    const uniqueMarkers = data.reduce((acc, curr) => {
      if (acc.has(curr.id)) {
        return acc;
      }

      const markerItem = {
        id: curr.id,
        name: curr.customer_name || curr.name
      };

      acc.set(markerItem.id, markerItem);

      return acc;
    }, new Map());

    const mapMarkersOptions = {};

    uniqueMarkers.forEach((value, key) => {
      let markerOptions;

      const iconMappingSystemKeys = Object.keys(mapMarkerSetting);

      if (iconMappingSystemKeys.length === 0) {
        markerOptions = {
          [key]: {
            icon: 23,
            color: iconColorPalette[4],
            style: 'proximity',
            name: value.name
          }
        };
      } else if (iconMappingSystemKeys.includes(key)) {
        markerOptions = {
          [key]: {
            icon: getIconIndex(mapMarkerSetting[key].icon),
            color: mapMarkerSetting[key].color,
            style: mapMarkerSetting[key].style,
            name: value.name
          }
        };
      } else {
        markerOptions = {
          [key]: {
            icon: getIconIndex(mapMarkerSetting['Default Marker'].icon),
            color: mapMarkerSetting['Default Marker'].color,
            style: mapMarkerSetting['Default Marker'].style,
            name: value.name
          }
        };
      }

      Object.assign(mapMarkersOptions, markerOptions);
    });

    const userMarkerSetting = localStorage.getItem('iconMappingUser')
      ? JSON.parse(localStorage.getItem('iconMappingUser'))
      : {};

    return { ...mapMarkersOptions, ...userMarkerSetting };
  };

  useEffect(() => {
    const mapMarkersOptions = combineUserAndSystemMapMarkerOptions();
    setCustomizationMarkersOptions(mapMarkersOptions);
  }, [data, isOpen, mapMarkerSetting]);

  return {
    isOpen,
    selectedRow,
    customizationMarkersOptions,

    setCustomizationMarkersOptions,
    toggleIsOpen,
    setSelectedRow,
    handleSave
  };
};
